/*
 * @Description: 微信平台数字品牌价值及三维度
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 11:27:36
 * @LastEditTime: 2019-06-28 15:00:36
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p9.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts/ExportEcharts';

import {getReportOneDayDB, getReportOneDayDimensions} from '../../../controller';
import {brandValueLine, brandValueBar} from '../../../chart';
import {toThousands} from '../../../utils';
import moment from 'moment';

class Platform extends React.Component {
  constructor () {
    super();

    this.state = {
      name: '',
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        maxDate: '',
        maxDb: '',
        minDate: '',
        minDb: '',

        maxFavorability: '',
        maxFavorabilityDate: '',
        maxParticipate: '',
        maxParticipateDate: '',
        maxSpread: '',
        maxSpreadDate: '',
        minFavorability: '',
        minFavorabilityDate: '',
        minParticipate: '',
        minParticipateDate: '',
        minSpread: '',
        minSpreadDate: ''
      },
      line: {},
      bar: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }


  getData () {
    const {query, name} = this.props;

    this.setState({
      query: query,
      name: name
    });

    this.getBarData(query);
    this.getLineData(query);
  }

  /**
   * 获取微信平台单日DB值
   * @param {*} query
   * @memberof P9
   */
  getBarData (query) {
    const { name } = this.props;
    getReportOneDayDB(query)
      .then(data => {
        const summary = this.state.summary;
        
        let obj = {
          rotate: true,
          platformName: name || '微信'
        }

        if (name === '汇总') {
          obj.title = `单日DB值`
        }

        this.setState({
          summary: Object.assign({}, summary, {
            maxDate: data.maxDate,
            maxDb: data.maxDb,
            minDate: data.minDate,
            minDb: data.minDb,
          }),
          bar: brandValueBar(data, Object.assign(obj, query), this.props.color)
        })
      });
  }

  /**
   * 获取微信平台单日维度曲线
   * @param {*} query
   * @memberof P9
   */
  getLineData (query) {
    const { name } = this.props;
    getReportOneDayDimensions(query)  
      .then(data => {
        const summary = this.state.summary;

        let obj = {
          rotate: true,
          platformName: name || '微信'
        }

        if (name === '汇总') {
          obj.title = `单日三维度曲线`
        }
        

        this.setState({
          summary: Object.assign({}, summary, {
            maxFavorability: data.maxFavorability,
            maxFavorabilityDate: data.maxFavorabilityDate,
            maxParticipate: data.maxParticipate,
            maxParticipateDate: data.maxParticipateDate,
            maxSpread: data.maxSpread,
            maxSpreadDate: data.maxSpreadDate,
            minFavorability: data.minFavorability,
            minFavorabilityDate: data.minFavorabilityDate,
            minParticipate: data.minParticipate,
            minParticipateDate: data.minParticipateDate,
            minSpread: data.minSpread,
            minSpreadDate: data.minSpreadDate
          }),
          line: brandValueLine(data, Object.assign(obj, query))
        })
      });
  }

  getDateStr (date) {
    return moment(date).format('M月D日');
  }

  render() {
    const {query, name, summary} = this.state;
    // const {} = this.props;
    return (
      <div className={s.container}>
        { name === '汇总'
            ? <ExportHeadTitle>数字品牌价值及三维度</ExportHeadTitle>
            : <ExportHeadTitle>{name}平台数字品牌价值及三维度</ExportHeadTitle>
        }

        { name === '汇总'
            ? (<div>
                <ExportDes>本周，{query.brandName}单日DB值波峰日为{this.getDateStr(summary.maxDate)}，达到{toThousands(summary.maxDb)}<em>DB</em>，波谷日为{this.getDateStr(summary.minDate)}，为{toThousands(summary.minDb)}<em>DB</em>。</ExportDes>
                <ExportDes>本周，{query.brandName}内容传播度在{this.getDateStr(summary.maxSpreadDate)}达到最高，参与度在{this.getDateStr(summary.maxParticipateDate)}达到最高，好感度在{this.getDateStr(summary.maxFavorabilityDate)}达到最高。</ExportDes>
              </div>)
            : (<div>
                <ExportDes>本周，{query.brandName}在{name}平台上的单日DB值波峰日为{this.getDateStr(summary.maxDate)}，达到{toThousands(summary.maxDb)}<em>DB</em>，波谷日为{this.getDateStr(summary.minDate)}，为{toThousands(summary.minDb)}<em>DB</em>。</ExportDes>
                <ExportDes>本周，{query.brandName}在{name}平台上的内容传播度在{this.getDateStr(summary.maxSpreadDate)}达到最高，参与度在{this.getDateStr(summary.maxParticipateDate)}达到最高，好感度在{this.getDateStr(summary.maxFavorabilityDate)}达到最高。</ExportDes>
              </div>)
        }

        <div className={s.echartWrapper}>
          <div>
            <ExportEcharts option={this.state.bar}></ExportEcharts>
          </div>
          <div>
            <ExportEcharts option={this.state.line}></ExportEcharts>
          </div>
        </div>

        <div className={s.notice}>* 单日DB值指：当天新发布内容的传播度、参与度和好感度的综合计算。非历史累积。</div>

        <ExportFootDes
          brandName={query.brandName}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(Platform);



// WEBPACK FOOTER //
// src/routes/exportPDF/p9/platform.js